/**
 * Hostname sent to `GET /tenant-branding/public?hostname=…`.
 * Prefer `VITE_TENANT_HOSTNAME` for local `localhost` admin against a remote/local API.
 */
export function resolvePublicBrandingHostname(args: {
  locationHostname: string;
  envHostname?: string | null;
}): string | undefined {
  const fromEnv = args.envHostname?.trim().toLowerCase().split(":")[0] ?? "";
  if (fromEnv) return fromEnv;

  const fromLocation = args.locationHostname.trim().toLowerCase().split(":")[0] ?? "";
  if (!fromLocation || fromLocation === "localhost" || fromLocation === "127.0.0.1") {
    return undefined;
  }
  return fromLocation;
}
